import { render, staticRenderFns } from "./common-tips.vue?vue&type=template&id=3c0a5e2e&scoped=true&"
import script from "./common-tips.vue?vue&type=script&lang=js&"
export * from "./common-tips.vue?vue&type=script&lang=js&"
import style0 from "./common-tips.vue?vue&type=style&index=0&lang=scss&module=productDetail&"
import style1 from "./common-tips.vue?vue&type=style&index=1&id=3c0a5e2e&lang=scss&scoped=true&"




function injectStyles (context) {
  
  this["productDetail"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3c0a5e2e",
  null
  
)

export default component.exports